import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import { toast } from "react-toastify";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import AdminCustomSelect from "../../../components/CommonComponents/AdminCustomSelect";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import Defaultloadinggif from "../../../layout/Others/Defaultloadinggif";
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import saveCustomFieldsStrict from "../../../CustomFields/saveCustomFieldsStrict";
import { getItemToken } from "../../../Utils/localStorageUtils";

function SidebarMenuAddUpdate() {

    const { fetchRequest, globalImageUplaodAPI } = useMyContext()

    const baseURL = process.env.REACT_APP_Baseurl
    const editApi = `${baseURL}/admin/sidebar_menu/edit`
    const storeApi = `${baseURL}/admin/sidebar_menu/store`
    const imageApi = globalImageUplaodAPI()
    const updateApi = `${baseURL}/admin/sidebar_menu/update`

    const navigate = useNavigate()
    const { id } = useParams()
    const headers = getItemToken('access_token')
    const combinedRef = useRef({});
    const [formDataError, setFormDataError] = useState({})
    const [formData, setFormData] = useState({ name: "", url: "site_url", in_menu: 0, in_icon: 0, active: 1, custom_url: "", select_url: "", parent_id: 0, });
    const [showOverlay, setShowOverlay] = useState(false);
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [loading, setLoading] = useState(false);
    const [darkImageFile, setDarkImageFile] = useState('');
    const [lightImageFile, setLightImageFile] = useState('');
    const [customFieldValues, setCustomFieldValues] = useState({});


    const formValidation = () => {
        let formIsValid = true;
        if (!formData?.name) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                name: "Sidebar Name cannot be empty.",
            }));
            combinedRef.current['name'].focus()
            formIsValid = false;
        }
        if (formData?.url == "site_url" && !formData?.select_url) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                select_url: "Site url cannot be empty.",
            }));
            combinedRef.current['select_url'].focus()
            formIsValid = false;
        }
        if (formData?.url == "custom_url" && !formData?.custom_url) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                custom_url: "Custom url cannot be empty.",
            }));
            combinedRef.current['custom_url'].focus()
            formIsValid = false;
        }
        return formIsValid;
    }

    const handleStore = (e) => {
        e.preventDefault()
        if (formValidation()) {
            if (!id) {
                handleAdd()
            }
            else {
                handleUpdate()
            }
        }
    }

    const handleFileUpload = async (id, name) => {
        try {
            const formDataAdd = new FormData();
            const imageFields = [];
            if (name == 'icon') {
                formDataAdd.append('image', lightImageFile)
                formDataAdd.append('dark_mode_image', darkImageFile)
                formDataAdd.append('id', id);
                formDataAdd.append('modelName', 'SidebarMenu');
                imageFields.push('image', 'dark_mode_image')
                imageFields.forEach((field) => {
                    formDataAdd.append('imageFields[]', field);
                });
                const response = await fetchRequest({
                    method: 'POST',
                    url: `${imageApi}`,
                    params: {},
                    data: formDataAdd,
                })
            }
            setDarkImageFile(null)
            setLightImageFile(null)
        } catch (err) {
            toast.error(err?.response?.data?.message)
        }
    }

    const handleAdd = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["parent_id", "order", "in_menu", "active", "in_icon", "name", "url", "select_url", "custom_url"].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }
            const response = await fetchRequest({
                method: 'POST',
                url: `${storeApi}`,
                params: {},
                data: formDataAdd,
            })
            const result = response;
            if (result?.status) {
                try {
                    await saveCustomFieldsStrict({ baseURL, headers, entityType: 'sidebar_menu', entityId: result?.id, values: customFieldValues });
                } catch (e) {
                    toast.error(e?.message || 'Failed to save additional fields');
                }
                if (darkImageFile || lightImageFile) {
                    await handleFileUpload(result?.id, 'icon')
                }
                setWithOutRefresh(!withOutRefresh)
                toast.success(result?.message)
                navigate("/sidebarmenu")
            }
        }
        catch (err) {
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
        }
        finally {
            setShowOverlay(false);
        }
    }

    const handleUpdate = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["parent_id", "order", "in_menu", "active", "in_icon", "name", "url", "select_url", "custom_url"].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }
            const response = await fetchRequest({
                method: 'PATCH',
                url: `${updateApi}/${id}`,
                params: {},
                data: formDataAdd,
            })
            const result = response;
            if (result?.status) {
                try {
                    await saveCustomFieldsStrict({ baseURL, headers, entityType: 'sidebar_menu', entityId: id, values: customFieldValues });
                } catch (e) {
                    toast.error(e?.message || 'Failed to save additional fields');
                }
                if (darkImageFile || lightImageFile) {
                    await handleFileUpload(id, 'icon')
                }
                toast.success(result?.message)
                setWithOutRefresh(!withOutRefresh)
            }
        }
        catch (err) {
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
        }
        finally {
            setShowOverlay(false)
        }
    }

    const handleInput = (e) => {
        const { name, type, value, checked } = e.target;
        if (type === 'checkbox') {
            setFormData((prev) => ({
                ...prev,
                [name]: checked ? 1 : 0,
            }));
        }
        if (type == "text" || type === 'select-one') {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }

        if (name === "url") {
            setFormDataError((prev) => ({
                ...prev,
                custom_url: "",
                select_url: "",
            }));
        }

        setFormDataError((prev) => ({
            ...prev,
            [name]: '',
        }));
    }

    const handleFileChange = async (event) => {
        const { files, name } = event.target
        setFormDataError((prev) => ({
            ...prev,
            [name]: "",
        }));

        if (files?.length > 0) {
            const newFile = files[0];
            if (name == 'dark') {
                setDarkImageFile(newFile);
            }
            if (name == 'light') {
                setLightImageFile(newFile);
            };
        }
    }

    const handleClearSelectFile = (value) => {
        if (value == 'dark') {
            setDarkImageFile(null)
        }
        if (value == 'light') {
            setLightImageFile(null)
        }
    }

    useEffect(async () => {
        if (id) {
            setLoading(true)
            await fetchRequest({
                method: 'GET',
                url: `${editApi}/${id}`,
                params: {},
                data: {},
            })
                .then(response => {
                    if (response?.status) {
                        setFormData((prev) => ({
                            ...prev,
                            ...response?.sidebar_menus,
                        }));
                    }
                }).catch((error => {
                    toast.error(error?.response?.data?.message)
                })).finally(() => {
                    setLoading(false)
                })
        }
    }, [withOutRefresh]);

    if (loading) {
        return <Defaultloadinggif className={"heightOnLoader"} />
    }

    return (
        <>
            {showOverlay && <Response_Processing></Response_Processing>}
            {<AdminBackNavigation path={`${'/sidebarmenu'}`} text="Back" />}
            <AdminSaveHeader heading={id ? "Edit Sidebar Menu" : "Add Sidebar Menu"} saveText={id ? "Update Sidebar Menu" : "Save Sidebar Menu"} saveMethod={handleStore} loading={showOverlay} />
            <FormContainer>
                <LeftWrapper>
                    <Wrapper>
                        <MessageHeading text={id ? "Update Menu" : "Create Menu"} />
                        <MessageLabel text="Sidebar Menu Name" className="mandatorySimple" />
                        <AdminCustomInput type="text" name="name" value={formData?.name} onChange={handleInput} placeHolder={"Enter name"} ref={(el) => (combinedRef.current.name = el)} error={formDataError?.name} />

                        <MessageLabel text="Menu Item URL" className="mandatorySimple" />
                        <AdminCustomSelect name="url" value={formData?.url} onChange={handleInput} ref={(el) => (combinedRef.current.url = el)} options={[{ name: "Site Url", value: "site_url" }, { name: "Custom Url", value: "custom_url" }]} error={formDataError?.url} defaultOptionName={""} />
                        {formData?.url == "site_url" &&
                            <>
                                <MessageLabel text="Menu Item URL" className="mandatorySimple" />
                                <AdminCustomInput type="text" name="select_url" value={formData?.select_url} onChange={handleInput} placeHolder={"Enter site url"} ref={(el) => (combinedRef.current.select_url = el)} error={formDataError?.select_url} appendText={`${process.env.REACT_APP_Baseurl_Frontend}/`} />
                            </>
                        }
                        {formData?.url == "custom_url" && <><MessageLabel text="Custom URL (ex. https || http)" className="mandatorySimple" />
                            <AdminCustomInput type="text" name="custom_url" value={formData?.custom_url} onChange={handleInput} placeHolder={"Enter custom url"} ref={(el) => (combinedRef.current.custom_url = el)} error={formDataError?.custom_url} />
                        </>}

                        <div className="card p-3 mt-3">
                            <FieldRenderer2
                                pageIdentifier={id ? "sidebar_menu.edit" : "sidebar_menu.create"}
                                entityType="sidebar_menu"
                                entityId={id}
                                text="Additional Fields"
                            />
                            <FieldRenderer
                                pageIdentifier={id ? "sidebar_menu.edit" : "sidebar_menu.create"}
                                entityType="sidebar_menu"
                                entityId={id}
                                onChange={setCustomFieldValues}
                            />
                        </div>
                    </Wrapper>

                    <Wrapper>
                        <MessageHeading text="Status Settings" />
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"Show In Sidebar"} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch name={'in_menu'} checked={formData?.in_menu == 1} onChange={handleInput} />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"Active/Inactive Status"} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch name={'active'} checked={formData?.active == 1} onChange={handleInput} />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"Icon Status"} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch name={'in_icon'} checked={formData?.in_icon == 1} onChange={handleInput} />
                            </div>
                        </div>
                    </Wrapper>
                </LeftWrapper>
                <RightWrapper>
                    <Wrapper>
                        <MessageHeading text='Menu Icon' />
                        <MessageLabel text="Dark Mode" />
                        <AdminImageUploadZone
                            onChange={handleFileChange}
                            selectedFile={darkImageFile}
                            uploadedImage={formData?.dark_mode_image}
                            onDelete={handleClearSelectFile}
                            ref={(el) => (combinedRef.current.dark_mode_image = el)}
                            name="dark"
                            id={id}
                            error={formDataError?.dark_mode_image}
                        />
                        <MessageLabel text="Light Mode" />
                        <AdminImageUploadZone
                            onChange={handleFileChange}
                            selectedFile={lightImageFile}
                            uploadedImage={formData?.image}
                            onDelete={handleClearSelectFile}
                            ref={(el) => (combinedRef.current.image = el)}
                            name="light"
                            id={id}
                            error={formDataError?.image}
                        />
                    </Wrapper>
                </RightWrapper>
                <AdminCustomButton saveMethod={handleStore} type="submit" saveText={id ? "Update Sidebar Menu" : "Save Sidebar Menu"} className="ms-auto" loading={showOverlay} />
            </FormContainer>
        </>
    );
}
export default SidebarMenuAddUpdate;